import { Alert, Stack } from "@mui/material";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { fetchOssReport, getOssReportCsvUrl } from "../../api/ossApi";
import { OssPageHeader } from "../../components/common/OssPageHeader";
import { OssReportFilter } from "../../components/reports/OssReportFilter";
import { OssReportSummary } from "../../components/reports/OssReportSummary";
import { OssReportTables } from "../../components/reports/OssReportTables";
import { useOssAsyncData } from "../../hooks/useOssAsyncData";

const now = new Date();
const initialRange = {
  from: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`,
  to: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()).padStart(2, "0")}`,
};

export const OssReports = () => {
  const { group_code, project_code } = useParams();
  const [range, setRange] = useState(initialRange);
  const [query, setQuery] = useState(initialRange);
  const { data, loading, error } = useOssAsyncData({
    fetcher: () => fetchOssReport(group_code, project_code, query),
    fallbackData: { summary: {}, exceptions: [], changes: [] },
    errorMessage: "보고서 데이터를 불러오지 못했습니다.",
    deps: [group_code, project_code, query],
  });

  return (
    <Stack spacing={1.5}>
      <OssPageHeader
        title="보고서"
        iconName="chartIcon"
      />
      {error && <Alert severity="warning">{error}</Alert>}
      <OssReportFilter
        from={range.from}
        to={range.to}
        onChange={(key, value) => setRange((prev) => ({ ...prev, [key]: value }))}
        onSearch={() => setQuery(range)}
        onDownload={() => window.open(getOssReportCsvUrl(group_code, project_code, query), "_blank", "noopener,noreferrer")}
      />
      <OssReportSummary summary={data.summary} />
      <OssReportTables report={data} loading={loading} />
    </Stack>
  );
};
